import { Chip } from '@mui/material';
import React from 'react';
import { GuideData, TroubleshootTagData } from '../types/types';

export interface BadgeListProps {
  expandable: boolean;
  limit: number | null;
  item: GuideData;
  tagData: TroubleshootTagData;
}

const BadgeList: React.FC<BadgeListProps> = ({ expandable, limit, item, tagData }) => {
  const [isExpanded, setIsExpanded] = React.useState<boolean>(false);

  const getTagName = (tagId: number) => {
    const tag = tagData.flatMap((tagCategory) => tagCategory.tags).find((singleTag) => singleTag.id === tagId)?.name;
    return tag ?? '-';
  };

  const tagItemMap = (tagIds: number[]): React.JSX.Element[] => {
    const tagNames = tagIds.map((tagId) => getTagName(tagId));
    const tags = !isExpanded && limit && tagNames.length > limit ? [...tagNames.slice(0, limit), `+ ${item.tags.length - limit}`] : tagNames;
    return tags.map((tagName, tagIndex) => {
      return <Chip color="primary" key={tagIndex} label={tagName} />;
    });
  };

  if (expandable) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          gap: '5px',
          cursor: 'pointer'
        }}
        onClick={() => setIsExpanded(!isExpanded)}>
        {tagItemMap(item.tags)}
      </div>
    );
  } else {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignContent: 'center',
          justifyContent: 'flex-end',
          gap: '5px',
          cursor: 'pointer',
          width: '50%'
        }}>
        {tagItemMap(item.tags)}
      </div>
    );
  }
};

export default BadgeList;
